import {BeaconTrigger, WiFiApTrigger} from "../../components/types";

const MAC_WITH_DELIMITER = /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/;
const MAC_NO_DELIMITER = /^([0-9A-F]{12})$/;

export const isValidCueBeaconMac = (value?: string) => {
    if (!value) {
        return false;
    }
    const trimmed = value.trim().toUpperCase();
    return MAC_WITH_DELIMITER.test(trimmed) || MAC_NO_DELIMITER.test(trimmed);
};

export const normalizeCueBeaconTrigger = (trigger: BeaconTrigger): BeaconTrigger | undefined => {
    const macAddr = (trigger.macAddr || "").trim().toUpperCase();
    if (!macAddr || !isValidCueBeaconMac(macAddr)) {
        return undefined;
    }
    const uuid = (trigger.uuid || "").trim().toUpperCase();
    const note = (trigger.note || "").trim();
    return {
        ...trigger,
        type: "Beacon",
        macAddr,
        majorId: trigger.majorId || "",
        minorId: trigger.minorId || "",
        uuid: uuid.length > 0 ? uuid : undefined,
        note: note.length > 0 ? note : undefined
    };
};

export const normalizeCueWiFiTrigger = (trigger: WiFiApTrigger): WiFiApTrigger | undefined => {
    const name = (trigger.name || "").trim();
    if (!name) {
        return undefined;
    }
    return {
        ...trigger,
        type: "WiFiAP",
        name
    };
};

export const cloneCueBeaconTriggers = (triggers?: BeaconTrigger[]) => {
    return (triggers || []).map((trigger) => ({...trigger}));
};

export const cloneCueWiFiTriggers = (triggers?: WiFiApTrigger[]) => {
    return (triggers || []).map((trigger) => ({...trigger}));
};
